/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FiMinus, FiPlus } from 'react-icons/fi';
import { PACKAGE_LIMITS } from '../../constants/packageConstants';
import {
  PACKAGE_PAX_TYPES,
  adultsOf,
  formatPrice,
  infantsOf,
  totalPaxOf,
} from '../../utils/packageUtils';

/**
 * One stepper row per sharing type. Twin and triple move a whole room at a
 * time. `types` limits the rows (the package page shows only what the chosen
 * price sells) and `rates` replaces the hint with the per-person price.
 */
function PackagePaxSteppers({ pax, onChange, types, rates, currency }) {
  const total = totalPaxOf(pax);

  return (
    <div className="pkg-pax-steppers">
      {types.map((t) => {
        const value = Number(pax[t.key]) || 0;
        const overMax = total + t.step > PACKAGE_LIMITS.MAX_PAX;
        const infantCap =
          t.kind === 'INFANT' && infantsOf(pax) >= adultsOf(pax);
        const canAdd = value + t.step <= t.max && !overMax && !infantCap;
        const rate = rates?.[t.key];
        return (
          <div className="pkg-stepper-row" key={t.key}>
            <div className="pkg-stepper-row__label">
              <strong>{t.label}</strong>
              <small>
                {rate != null
                  ? `${formatPrice(rate, currency)} per person`
                  : t.hint}
              </small>
            </div>
            <div className="pkg-stepper">
              <button
                type="button"
                disabled={value <= 0}
                onClick={() =>
                  onChange({ ...pax, [t.key]: Math.max(0, value - t.step) })
                }
                aria-label={`Remove ${t.label}`}
              >
                <FiMinus size={14} />
              </button>
              <span>{value}</span>
              <button
                type="button"
                disabled={!canAdd}
                onClick={() => onChange({ ...pax, [t.key]: value + t.step })}
                aria-label={`Add ${t.label}`}
              >
                <FiPlus size={14} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

PackagePaxSteppers.propTypes = {
  pax: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  types: PropTypes.array,
  rates: PropTypes.object,
  currency: PropTypes.string,
};

PackagePaxSteppers.defaultProps = {
  types: PACKAGE_PAX_TYPES,
  rates: null,
  currency: 'INR',
};

export default PackagePaxSteppers;
